export enum PresenceSeuil {
    Inconnue = 0,
    Amont = 1,
    Aval = 2,
    Absence = 3,
    EntreDeuxSeuils = 4,
    PrelevementSurSeuil = 5,
    SeuilInterieurStation = 6,
    PlusieursSeuilsInterieurStation = 7
}
